import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitListItemExtensionInterface } from '../../../extension/interface/benefit-list-item.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { MobilityBenefitListItemExtension } from './mobility-benefit-list-item.extension';
import { MobilityBenefitMetadataExtension } from './mobility-benefit-metadata.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('mobility')
    .add(BenefitMetadataExtensionInterface, new MobilityBenefitMetadataExtension())
    .add(BenefitListItemExtensionInterface, new MobilityBenefitListItemExtension())
    .build(),
);
